import Type from './Type';
export function isILinkRandom(discourse) {
    return discourse.type === Type.Random;
}
export {
    isILinkRandom as isIRandom
};
export default isILinkRandom;    //# sourceMappingURL=isIRandom.js.map
